import { useDispatch, useSelector } from 'react-redux';
import { FORM_TYPE_CREATE_CDC } from 'js/constants/formTypes';
import { useCallback, useMemo } from 'react';
import { updateFormData as updateFormDataAction } from 'js/actions';
import useFlowsSetup from 'new/components/flows/controller/useFlowsSetup';
import flowTypes from 'new/components/flows/types/flowTypes';
import { createResourceSetupService } from 'new/components/flows/types/replication/CreateReplicationFlow/ResourceSetup/service/createResourceSetupService';
import usePaging from 'new/state/paging/repository/usePaging';

export default function useCDC(): {
  updateFormData: (data: any) => void;
  updateCDCResourceConfig: (data: any) => void;
  [key: string]: any;
} {
  const dispatch = useDispatch();

  const paging = usePaging();

  const service = createResourceSetupService();

  const { onSelectConnection, updateFormData, resetFormData } = useFlowsSetup(
    FORM_TYPE_CREATE_CDC,
    flowTypes.cdc,
  );
  const data = useSelector((state: any) => state.forms[FORM_TYPE_CREATE_CDC]?.data);

  const updateCDCResourceConfig = useCallback(
    (resourceConfig) => {
      dispatch(
        updateFormDataAction(FORM_TYPE_CREATE_CDC, {
          resourceConfig: {
            ...data?.resourceConfig,
            ...resourceConfig,
          },
        }),
      );
    },
    [dispatch, data],
  );

  const connectionCategory = paging.getConnectionCategoryByConnectorType(data?.selectedConnection);

  return useMemo(() => {
    return {
      ...data,
      connectionCategory,
      updateFormData,
      resetFormData,
      onSelectConnection: onSelectConnection(flowTypes.cdc),
      allowCustomPrefixEditor: service.canEditPrefix({
        connectionCategory,
        selectedBucket: data?.selectedBucket,
        sinkConfig: data?.sinkConfig,
      }),
      updateCDCResourceConfig,
    };
  }, [data, updateFormData, updateCDCResourceConfig]);
}
